import { HTTP } from '../../axios/axios'
import store from '../../store/index'
let data

async function getAll (lang) {
  try {
    const res = await HTTP.get('/customer-stories', { headers: { 'accept-language': lang } })
    data = res.data
    return res.data.stories
  } catch (error) {
    console.log(error)
  }
}
async function addOne (story, lang) {
  return await HTTP.patch('/customer-stories', { stories: [...store.state.data, story] }, { headers: { 'accept-language': data.lang } })
}
async function update (story, id) {
  return await HTTP.patch('/customer-stories', { stories: store.state.data }, { headers: { 'accept-language': data.lang } })
}
async function deleteOne (story) {
  let stories = store.state.data
  stories = stories.filter(i => i._id !== story._id)
  return await HTTP.patch('/customer-stories', { stories: stories }, { headers: { 'accept-language': data.lang } })
}

async function deleteMany (arr) {
  let stories = store.state.data
  stories = stories.filter(i => arr.indexOf(i._id) === -1)
  return await HTTP.patch('/customer-stories', { stories: stories }, { headers: { 'accept-language': data.lang } })
}

export default { getAll, deleteMany, addOne, update, deleteOne }
